module.exports = __webpack_public_path__ + "img/studentBigBox.7838e661.png";